<h3 class="role-modal__header">{{ modalData.title | translate }}</h3>

@let canManage = (isRoleManagementAllowed$ | async) ?? false;
@let isRoleProcessing = roleManagementService.loadingState() === LoadingState.LOADING;
@let areRolePermissionsLoaded = rolePermissionsService.loadingState() === LoadingState.READY;

<div class="role-modal__input-area">
  <lib-input
    class="role-modal__input"
    type="text"
    [readonly]="roleNameControl.disabled"
    [formControl]="roleNameControl"
    [placeholder]="'monitoring.roles.modal.role-name' | translate"
    [label]="'monitoring.roles.modal.role-name' | translate"
    [libSkeleton]="isRoleProcessing"
  />
</div>

@if (roleNameControl.hasError('pattern') && (roleNameControl.dirty || roleNameControl.touched)) {
  <p class="role-modal__error error-text">
    {{ 'monitoring.roles.modal.name-input-pattern-error' | translate }}
  </p>
}

@if (areRolePermissionsLoaded) {
  <h4 class="role-modal__subheader">
    {{ 'monitoring.roles.modal.permissions' | translate }}
    <span class="role-modal__asterisk">*</span>
  </h4>

  @if (isSystemRole) {
    <div class="role-modal__warning">
      {{ 'monitoring.roles.modal.warning' | translate }}
    </div>
  }
}

<div class="role-modal__permissions">
  @if (!areRolePermissionsLoaded) {
    <div
      class="role-modal__permission-skeleton"
      [libSkeleton]="true"
    ></div>
    <div
      class="role-modal__permission-skeleton"
      [libSkeleton]="true"
    ></div>
    <div
      class="role-modal__permission-skeleton"
      [libSkeleton]="true"
    ></div>
  }

  @for (group of permissionGroups(); track $index) {
    <div class="role-modal__permission-group">
      <lib-svg-icon
        class="role-modal__permission-group-icon"
        (click)="toggleVisibleGroup(group)"
        [icon]="group.hidden ? 'arrow-up' : 'arrow-down'"
        [libSkeleton]="isRoleProcessing"
      />

      <lib-checkbox
        class="role-modal__permission-group-checkbox"
        (ngModelChange)="togglePermissionGroup(group)"
        [ngModel]="group.selected"
        [libSkeleton]="isRoleProcessing"
        [disabled]="!canManage || isSystemRole || isRoleProcessing"
      >
        {{ group.name }}
      </lib-checkbox>
    </div>

    @for (permission of group.permissions; track $index) {
      <lib-checkbox
        class="role-modal__permission"
        [class.role-modal__permission--hidden]="group.hidden"
        (ngModelChange)="togglePermission(group, permission)"
        [ngModel]="permission.selected"
        [libSkeleton]="isRoleProcessing"
        [disabled]="!canManage || isSystemRole || isRoleProcessing"
      >
        {{ permission.name }}
      </lib-checkbox>
    }
  }
</div>

@if (canManage) {
  <div class="role-modal__buttons">
    @if (isEditingMode) {
      <lib-icon-button
        (click)="deleteRole()"
        [disabled]="isSystemRole || isRoleProcessing"
        [title]="'monitoring.roles.modal.delete-role' | translate"
        [libSkeleton]="isRoleProcessing"
        icon="trash"
        buttonStyle="filled"
        [size]="24"
        type="button"
      />
    }

    <lib-button
      class="role-modal__save-button"
      (click)="saveChanges()"
      [disabled]="
        roleNameControl.invalid ||
        isSystemRole ||
        getSelectedPermissionIds().length === 0 ||
        isRoleProcessing
      "
      [libSkeleton]="isRoleProcessing"
      buttonSize="large"
      type="button"
    >
      {{
        (isCreatingMode
          ? 'monitoring.roles.modal.create-role'
          : 'monitoring.roles.modal.save-edits'
        ) | translate
      }}
    </lib-button>
  </div>
}
